import { msg } from "@lingui/macro"
import { useLingui } from "@lingui/react"

interface Props {
  className?: string
}

export function FiltersIcon(props: Props) {
  const { _ } = useLingui()

  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g id="Frame">
        <title>{_(msg`Filters Icon`)}</title>
        <path
          id="Vector"
          d="M14.4 4H7.19995"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Vector_2"
          d="M9.60002 12H2.40002"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Vector_3"
          d="M12 14.4C13.3255 14.4 14.4 13.3255 14.4 12C14.4 10.6745 13.3255 9.60001 12 9.60001C10.6745 9.60001 9.59998 10.6745 9.59998 12C9.59998 13.3255 10.6745 14.4 12 14.4Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Vector_4"
          d="M3.99998 6.40001C5.32546 6.40001 6.39998 5.32549 6.39998 4.00001C6.39998 2.67452 5.32546 1.60001 3.99998 1.60001C2.67449 1.60001 1.59998 2.67452 1.59998 4.00001C1.59998 5.32549 2.67449 6.40001 3.99998 6.40001Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  )
}
